<GoogleAnalytics properties="{[gaProperty]}" />
<Popup />
<Router
  routes="{routes}"
  restoreScrollState="{true}"
  on:routeLoaded="{routeLoaded}"
/>

{#if demoData}
  <DemoControl />
{/if}

<!-- <SupportNav></SupportNav> -->
<script>
import { GoogleAnalytics } from "@beyonk/svelte-google-analytics";

import Router, { push, replace } from "svelte-spa-router";
import { wrap } from "svelte-spa-router/wrap";
import {
  currentChapter,
  demoSetup,
  loggedIn as loggedInData,
  currentPopup,
  currentContent,
  chapterSwitched,
} from "./stores";
import Home from "./Home.svelte";
import ErrorNotFound from "./ErrorNotFound.svelte";
import ChapterOverview from "./ChapterOverview.svelte";
import ChapterExam from "./ChapterExam.svelte";
import ChapterRules from "./ChapterRules.svelte";
import ChapterVideo from "./ChapterVideo.svelte";
import About from "./About.svelte";
import ChapterFinished from "./ChapterFinished.svelte";
import Login from "./Login.svelte";
import HomeIntro from "./HomeIntro.svelte";
import HomeManager from "./HomeManager.svelte";
import DemoAssign from "./DemoAssign.svelte";
import Datenschutz from "./Datenschutz.svelte";
import { progressSvc as _ } from "./services/progress.service";
import { gaProperty } from "./constants";
import Popup from "./general/Popup.svelte";
import DemoControl from "./DemoControl.svelte";
import { demoSvc } from "./services/demo.service";
import Register from "./Register.svelte";
import { chaptersSvc } from "./services";
import Agb from "./AGB.svelte";
import Impressum from "./Impressum.svelte";
import ErrorThirdPartySecurity from "./ErrorThirdPartySecurity.svelte";
import SupportNav from "./SupportNav.svelte";

export let pageContents;

let loggedIn = false,
  demoData,
  currentChapterSlug,
  chaptersInitialized;
const isDemo = demoSvc.isDemoInstance();
loggedInData.subscribe((status) => (loggedIn = status));
demoSetup.subscribe((data) => (demoData = data));
currentChapter.subscribe((data) => {
  if (!data) {
    return;
  }
  if (!currentChapterSlug || currentChapterSlug !== data.slug) {
    currentChapterSlug = data.slug;
    chapterSwitched.set(data.slug);
  }
});

const isAllowedChapter = (detail) => {
  if (!isDemo) {
    return true;
  }
  const allowed = detail.location.indexOf("/abschlag/") !== -1;
  if (!allowed) {
    push("/platzreife");
  }
  return allowed;
};

const routesData = [
  {
    path: "/",
    data: { component: ErrorNotFound, conditions: () => replace("/login") },
  },
  { path: "/demo", data: { component: DemoAssign } },
  { path: "/impressum", data: { component: Impressum } },
  { path: "/agb", data: { component: Agb } },
  { path: "/datenschutz", data: { component: Datenschutz } },
  {
    path: "/home",
    data: { component: Home, conditions: [() => isLoggedIn()] },
  },
  {
    path: "/intro",
    data: { component: HomeIntro, conditions: [() => isLoggedIn()] },
  },
  {
    path: "/manager",
    data: { component: HomeManager, conditions: [() => isLoggedIn()] },
  },
  {
    path: "/login",
    data: {
      component: Login,
      conditions: [
        () => {
          isLoggedIn() && push("/home");
          return true;
        },
      ],
    },
  },
  {
    path: "/registrieren",
    data: {
      component: Register,
      conditions: [
        // () => !isLoggedIn(),
        () => (demoSvc.isDemoInstance() && push("/login")) || true,
      ],
    },
  },
  {
    path: "/ueber-uns",
    data: { component: About, conditions: [() => isLoggedIn()] },
  },
  {
    path: "/platzreife",
    data: { component: ChapterOverview, conditions: [() => isLoggedIn()] },
  },
  {
    path: "/platzreife/:lektion",
    data: {
      component: ChapterVideo,
      conditions: [() => isLoggedIn(), isAllowedChapter],
    },
  },
  {
    path: "/platzreife/:lektion/video",
    data: {
      component: ChapterVideo,
      conditions: [() => isLoggedIn(), isAllowedChapter],
    },
  },
  {
    path: "/platzreife/:lektion/regeln",
    data: {
      component: ChapterRules,
      conditions: [() => isLoggedIn(), isAllowedChapter],
    },
  },
  {
    path: "/platzreife/:lektion/pruefung",
    data: {
      component: ChapterExam,
      conditions: [() => isLoggedIn(), isAllowedChapter],
    },
  },
  {
    path: "/platzreife/:lektion/beantwortet",
    data: {
      component: ChapterFinished,
      conditions: [() => isLoggedIn(), isAllowedChapter],
    },
  },

  { path: "/error-security", data: { component: ErrorThirdPartySecurity } },
  // Catch-all
  // This is optional, but if present it must be the last
  { path: "*", data: { component: ErrorNotFound } },
];

const getRouteSelect = (key) => {
  // catchall fallback
  key = key === "*" ? "/nicht/gefunden" : key;

  const removeRouteChars = (str) => str.replace(/:/g, "").replace(/\?/g, "");
  return {
    routeKey: "page_" + removeRouteChars(key).slice(1).replace(/\//g, "_"),
    // routeLabel wird im wordpress be-golf-cpt.php verwendet
    // routeLabel: key.slice(1).split('/').filter(p => !!p).map(removeRouteChars).map(part => part[0].toUpperCase() + part.slice(1)).join(' ')
    routeLabel: key,
  };
};

const routes = new Map();
for (let i = 0; i < routesData.length; i++) {
  const entry = routesData[i];
  if (!entry.data.userData) {
    entry.data.userData = {};
  }
  entry.data.userData.pageMeta = getRouteSelect(entry.path);
  routes.set(entry.path, wrap(entry.data));
}

function routeLoaded(event) {
  const routeKey = event.detail.userData.pageMeta.routeKey;
  const pageContent = pageContents[routeKey];
  currentContent.set(pageContent);
  let popupData;
  if (pageContent?.popup) {
    popupData = pageContent?.popup;
    popupData.routeKey = routeKey;
  }
  currentPopup.set(popupData || false);
  // !pageContent && console.debug(`Kein Inhalt für ${routeKey} gefunden`);

  if (!chaptersInitialized && routeKey.indexOf("platzreife") !== -1) {
    chaptersInitialized = true;
    chaptersSvc.initializeChapters();
  }
}

// TO BE USED IN be-golf-cpt.php START
// const cptSelect = {};
// for (let i = 0; i < routesData.length; i++) {
//   const data = getRouteSelect(routesData[i].path);
//   cptSelect[data.routeKey] = data.routeLabel;
// }
// console.log(JSON.stringify(cptSelect))
// TO BE USED IN be-golf-cpt.php END

const handleIsLoggedIn = () => {
  // DEMO only
  if (loggedIn && demoData?.name) {
    return true;
  }
  if (!demoData) {
    push("/demo");
  } else {
    push("/login");
  }
  return false;
};

const isLoggedIn = () => {
  if (isDemo) {
    return handleIsLoggedIn();
  }

  if (!loggedIn) {
    push("/login");
  }
  return loggedIn;
};
</script>

<style type="text/scss">
@import "./scss/colors";
@import "./scss/bulma-overrides";
:global(html, body) {
  position: relative;
  width: 100%;
  height: 100%;
}

:global(h1, h2, h3, h4, h5) {
  text-transform: uppercase;
  font-family: "Oswald", "Open Sans", sans-serif, Arial, Helvetica;
  font-weight: 700;
}

:global(.nav-popover) {
  height: 40px;
}
</style>
